<i18n>
zh: 
    select: 请选择
ru: 
    select: Выбирай
</i18n>
<template>
    <div class="select">
        <div class="title">{{data.name}}</div>
        <div class="input">
            <div class="placeholder">--{{$t('select')}}--</div>
            <div class="list">
                <a class="item" v-for="item in data.list" :key="item.id" :href="item.url" target="_block">{{item.name}}</a>
            </div>
        </div>
    </div>
</template>

<script>
export default {
    name: "footerSelect",
    props: ['data'],
    data() {
        return {
            isShow: false,
        };
    },
    computed: {},
    components: {
        
    },
    mounted() {},
    destroyed() {},
    watch: {},
    methods: {},
};
</script>

<style scoped lang="scss">
.select{
    display: flex;
    align-items: center;
    color: #ffffff;
    font-size: 14px;
    margin-right: 20px;
    .title{
        margin-right: 10px;
        line-height: 1;
    }
    .input{
        width: 210px;
        height: 30px;
        line-height: 30px;
        background: #fff;
        color: #3f87cf;
        font-size: 12px;
        position: relative;
        .placeholder{
            padding: 0 10px;
            cursor: pointer;
            display: flex;
            justify-content: space-between;
            align-items: center;
            &::after{
                content: "";
                display: block;
                width: 5px;
                height: 5px;
                border-bottom: 2px solid #3f87cf;
                border-right: 2px solid #3f87cf;
                transform: rotate(45deg) translate(0, -50%);
            }
        }
        &:hover{
            .list{
                display: block;
            }
        }
        .list{
            display: none;
            position: absolute;
            top: 100%;
            left: 0;
            width: 100%;
            padding-top: 2px;
            .item{
                background: #fff;
                padding: 0 10px;
                line-height: 30px;
                display: block;
                &:hover{
                    background: #3f87cf;
                    color: #fff;
                }
            }
        }
    }
    @media only screen and (max-width: 1024px) {
        margin-right: .2rem;
        .title{
            display: none;
        }
        .input{
            width: 1.8rem;
            height: .25rem;
            line-height: .25rem;
            font-size: .12rem;
            .placeholder{
                padding: 0 .1rem;
                &::after{
                    border-width: 1px;
                }
            }
            .list{
                .item{
                    line-height: .5rem;
                    padding: 0 .1rem;
                }
            }
        }
    }
}
</style>